import { createSelector } from 'reselect';
import { prefixInteger } from '@laigu/utils';
import _ from 'lodash';

// 补全子元素的color
// 一级标签按标签id升序排列，即新加标签排在下方；
// 二级标签先按照父标签分组，同一个父标签下再按标签id升序排列；
// 三级标签同理，先按照一级标签分组，再按照二级标签分组，同一个二级父标签下按标签id升序
const emptyArray = [];
const buildChildConvTag = createSelector([convTag => convTag], convTag => {
  if (convTag?.length === 0) {
    return emptyArray;
  }
  const setChildColor = (id, color) => {
    const index = convTag.findIndex(val => val.id === id);
    convTag[index].color = color;
  };
  const setOrder = (id, order) => {
    const index = convTag.findIndex(val => val.id === id);
    convTag[index].order = order;
  };
  // 初始化 最上层的order
  convTag
    .filter(val => val.level === 1)
    .forEach(val => {
      setOrder(val.id, prefixInteger(val.id, 8));
    });

  [2, 3, 4].forEach(level => {
    const nowTags = convTag.filter(val => val.level === level);
    const parentTags = convTag.filter(val => val.level === level - 1);
    nowTags.forEach(nowTag => {
      const parent = parentTags.find(parentTag => parentTag.id === nowTag.parent_id);
      if (parent) {
        setChildColor(nowTag.id, parent.color);
        setOrder(nowTag.id, `${parent.order}_${prefixInteger(nowTag.id, 6)}`);
      }
    });
  });
  convTag.sort((a, b) => a.id - b.id);
  return convTag;
});

const parseConvTag = createSelector([data => buildChildConvTag(data)], data => {
  return data.map(val => ({
    ...val,
    label: val.tag_name,
    value: val.id
  }));
});

// 通过tagids获取对话标签
const getConvTag = createSelector([tagIds => tagIds, (tagIds, convTag) => convTag], (ids, list) => {
  if (ids && ids.length) {
    const arr = [];
    ids.forEach(data => {
      const item = _.find(list, ['id', data]);
      if (item) {
        arr.push(item);
      }
    });
    return arr;
  }
  return [];
});

// 自定义级联组件专用
const getConvTagTreeList = createSelector([data => data], data => {
  const convTagMap = {};

  function getChildren(data, level, parentId, color, parent) {
    let newData = [];
    const children = data.filter(d => d.level === level && (parentId ? d.parent_id === parentId : true));
    if (children.length > 0) {
      newData = children.map(c => {
        const i = {
          ...c,
          name: c.tag_name,
          key: c.id,
          value: c.id,
          active: false,
          label: c.tag_name,
          title: c.tag_name,
          fullName: parent ? `${parent.fullName}/${c.tag_name}` : c.tag_name
        };
        const subChildren = getChildren(data, level + 1, c.id, color || c.color, i);

        if (color) {
          i.color = color;
        }
        convTagMap[c.id] = { ...i };
        if (subChildren.length > 0) {
          i.children = subChildren;
        }
        i.cls = `${i.color} tag`;
        return i;
      });
    }
    return newData;
  }

  const treeList = getChildren(data, 1);
  return { convTagMap, convTagTree: treeList };
});

export default {
  getConvTag,
  buildChildConvTag,
  parseConvTag,
  getConvTagTreeList
};
